// extracted by mini-css-extract-plugin
export default {"root":"ProductConfgTemp_root__HWn9w"};